<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { NavItem } from '~/types/nav'

defineProps<{
  items: NavItem[]
  class?: HTMLAttributes['class']
}>()
</script>
<template>
  <nav :class="cn('flex', $props.class)">
    <HeaderNavItem v-for="(item, index) in items" :key="index" :to="item.path">
      <Icon v-if="item.icon" :name="item.icon" />
      {{ item.text }}
    </HeaderNavItem>
    <slot />
  </nav>
</template>
